import { IGetValueArgs } from "@components/smart/FieldInfo";
import { AttachmentsAdditionalProperties, AttachmentsDef } from "@components/smart/GeneralFieldDefinition";
import {
    EntitySetName,
    EntityTypeName,
    PrEmployeeEntity,
    PrYearOperationEntity,
    PrYearOperationPayrollSheetAttachmentEntity,
    PrYearOperationSectionEntity
} from "@odata/GeneratedEntityTypes";
import { setDefForTesting } from "@pages/getDefByEntityType";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";

import { BasicInputSizes, FieldType, LabelStatus, ValidatorType } from "../../../enums";
import { IFormDef } from "../../../views/formView/Form";

export const getDefinitions: IGetDefinition = (): IDefinition => {
    const form: IFormDef = {
        id: `${EntityTypeName.PrYearOperation}Form`,
        files: AttachmentsDef,
        translationFiles: getDefinitions.translationFiles,
        fieldDefinition: {
            [PrYearOperationEntity.DisabledShareByOrders]: {
                type: FieldType.NumberInput,
                labelStatus: LabelStatus.Removed,
                width: BasicInputSizes.S,
                isRequired: false,
                fieldSettings: {
                    unit: (args: IGetValueArgs) => {
                        const count = args.storage.getValueByPath(PrYearOperationEntity.DisabledShareByOrders) as number ?? 0;
                        return args.storage.t("PayrollYearOperation:MandatoryShareOfDisabledPeopleDeclaration.People", { count });
                    },
                },
                validator: {
                    type: ValidatorType.Integer,
                    settings: {
                        min: 0,
                    }
                }
            }
        },
        groups: [{
            id: "Main",
            rows: [[
                { id: PrYearOperationEntity.DisabledShareByOrders },
            ]]
        }],
        additionalProperties: [
            ...AttachmentsAdditionalProperties,
            {
                id: PrYearOperationEntity.Sections,
                additionalProperties: [
                    { id: PrYearOperationSectionEntity.Id },
                    { id: PrYearOperationSectionEntity.TypeCode },
                    { id: PrYearOperationSectionEntity.IsChecked },
                ]
            }, {
                id: PrYearOperationEntity.PrYearOperationPayrollSheets,
                additionalProperties: [
                    { id: "Id" },
                    {
                        id: PrYearOperationPayrollSheetAttachmentEntity.Employee,
                        additionalProperties: [
                            { id: PrEmployeeEntity.NumberOurs },
                            { id: PrEmployeeEntity.FirstName },
                            { id: PrEmployeeEntity.LastName },
                        ]
                    },
                    { id: PrYearOperationPayrollSheetAttachmentEntity.File }
                ]
            }
        ]
    };

    return {
        form,
        entitySet: EntitySetName.PrYearOperations
    };
};

getDefinitions.translationFiles = [];
setDefForTesting(EntityTypeName.PrYearOperation, getDefinitions);